import { useCookies } from "react-cookie";

export const BANNER_COOKIE_NAME = "closed_smart_app_banner"; // SP画面上部に出るバナー
export const BANNER_COOKIE_EXPIRATION_MS = 30 * 60 * 1000; // 30分のミリ秒換算

export const POP_UP_COOKIE_NAME = "closed_web_to_app_popup"; // SP画面下部に出るポップアップ
export const POP_UP_COOKIE_EXPIRATION_MS = 3 * 24 * 60 * 60 * 1000; // 3日間のミリ秒換算

export const useBannerCookies = () => {
  const [, setCookie] = useCookies([BANNER_COOKIE_NAME, POP_UP_COOKIE_NAME]);

  const setBannerAndPopupCookies = () => {
    setCookie(BANNER_COOKIE_NAME, true, {
      path: "/",
      expires: new Date(Date.now() + BANNER_COOKIE_EXPIRATION_MS),
    });
    setCookie(POP_UP_COOKIE_NAME, true, {
      path: "/",
      expires: new Date(Date.now() + POP_UP_COOKIE_EXPIRATION_MS),
    });
  };

  return { setBannerAndPopupCookies };
};
